export function activate (state) {
	state.status = `ACTIVE`;
}
